export type SiteLocale = 'tr' | 'en';

export function toSiteLocale(lang: string | undefined): SiteLocale {
  return lang === 'en' ? 'en' : 'tr';
}

export function pickLocalized<T>(lang: string | undefined, tr: T, en: T): T {
  return toSiteLocale(lang) === 'en' ? en : tr;
}
